/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { EventGroupsListComponent } from '@app/events/events-groups/event-groups-list/event-groups-list.component';
import { EventsListComponent } from '@app/events/events/events-list/events-list.component';
import { EventGroupsViewComponent } from '@app/events/events-groups/event-groups-view/event-groups-view.component';
import { EventsViewComponent } from '@app/events/events/events-view/events-view.component';
import { MenuService } from '@app/core/menu/menu.service';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'event-groups', component: EventGroupsListComponent, data: { title: extract('Event Groups') } },
    { path: 'event-groups/view', component: EventGroupsViewComponent, data: { title: extract('Event Groups view') } },
    { path: 'events', component: EventsListComponent, data: { title: extract('Events') } },
    { path: 'events/view', component: EventsViewComponent, data: { title: extract('Events view') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventsRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({
        key: 'events',
        title: 'Events',
        icon: 'fal fa-calendar-week',
      })
      .addItem({
        key: 'events.event-groups',
        requiredPermission: 'event_groups.menu',
        path: '/event-groups',
        title: 'Groups',
      })
      .addItem({
        key: 'events.events',
        requiredPermission: 'events.menu',
        path: '/events',
        title: 'Events',
      });
  }
}
